import * as tslib_1 from "tslib";
import ImportanceIcon from './ImportanceIcon';
import { observer } from 'mobx-react';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import updateSubject from 'owa-mail-compose-store/lib/actions/updateSubject';
import updateSubjectSelectionRange from 'owa-mail-compose-store/lib/actions/updateSubjectSelectionRange';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import { SubjectPicker } from 'owa-mail-subject-picker';
import { isSubjectPickerSupported } from 'owa-mail-subject-picker-connector';
import showHideSubjectPicker from 'owa-mail-compose-store/lib/actions/showHideSubjectPicker';
import updateLastFocusedControl from 'owa-mail-compose-store/lib/actions/updateLastFocusedControl';
import getRecipientsCount from 'owa-mail-compose-store/lib/utils/getRecipientsCount';
var styles = require('./ComposeTop.scss');
var MAX_SUBJECT_LENGTH = 255;
var SubjectLine = /** @class */ (function (_super) {
    tslib_1.__extends(SubjectLine, _super);
    function SubjectLine(props) {
        var _this = _super.call(this, props) || this;
        _this.focus = function () {
            _this.subjectInput.focus();
        };
        _this.onSubjectLineElementRendered = function (ref) {
            _this.subjectLineElement = ref;
            if (_this.props.composeViewState.subjectPickerViewState.isPickerOpened) {
                // We need to re-render in case we get back to tab containing subject picker
                _this.forceUpdate();
            }
        };
        _this.onSelect = function () {
            _this.updateSelectionRange();
        };
        _this.onSubjectChange = function () {
            updateSubject(_this.props.composeViewState, _this.subjectInput.value);
            if (_this.isSubjectPickerEnabled()) {
                if (_this.props.composeViewState.subjectPickerViewState.isPickerOpened &&
                    _this.subjectInput.value) {
                    showHideSubjectPicker(_this.props.composeViewState.subjectPickerViewState, false /* isOpened */, 'SubjectTyped');
                }
                if (_this.shouldOpenSubjectPicker()) {
                    showHideSubjectPicker(_this.props.composeViewState.subjectPickerViewState, true /* isOpened */, 'SubjectCleared');
                }
            }
        };
        _this.onSubjectInputFocus = function () {
            if (_this.isSubjectPickerEnabled() && _this.shouldOpenSubjectPicker()) {
                showHideSubjectPicker(_this.props.composeViewState.subjectPickerViewState, true /* isOpened */, 'InputFocused');
            }
            updateLastFocusedControl(_this.props.composeViewState, 5 /* SubjectLine */);
        };
        _this.onSubjectPickerDismiss = function (isDismissedOnCloseButton) {
            showHideSubjectPicker(_this.props.composeViewState.subjectPickerViewState, false /* isOpened */, isDismissedOnCloseButton ? 'PopupClosedByXButton' : 'PopupDismissed');
        };
        _this.onSubjectConversationSelected = function (conversation) {
            showHideSubjectPicker(_this.props.composeViewState.subjectPickerViewState, false /* isOpened */, 'ConversationSelected');
            updateSubject(_this.props.composeViewState, conversation.ConversationTopic);
        };
        _this.onKeyDown = function (target) {
            if (target.keyCode === 40 /* Down_arrow */ && _this.subjectPickerElement) {
                var innerComponent = _this.subjectPickerElement.getInnerComponent();
                if (innerComponent) {
                    target.preventDefault();
                    innerComponent.focus();
                }
            }
        };
        return _this;
    }
    SubjectLine.prototype.render = function () {
        var _this = this;
        var _a = this.props.composeViewState, subject = _a.subject, importance = _a.importance, subjectViewState = _a.subjectViewState;
        var isSubjectPickerEnabled = this.isSubjectPickerEnabled();
        return (React.createElement("div", { className: styles.subjectContainer },
            React.createElement("div", { className: styles.subjectIconContainer },
                React.createElement(ImportanceIcon, { importance: importance })),
            React.createElement("div", { className: styles.subjectLine, ref: this.onSubjectLineElementRendered },
                React.createElement(TextField, { id: subjectViewState.inputId, componentRef: function (ref) { return (_this.subjectInput = ref); }, className: styles.subject, value: subject, maxLength: MAX_SUBJECT_LENGTH, borderless: true, type: 'text', placeholder: strings.addSubjectPlaceholder, onChanged: this.onSubjectChange, onSelect: this.onSelect, onFocus: this.onSubjectInputFocus, onKeyDown: isSubjectPickerEnabled ? this.onKeyDown : undefined })),
            isSubjectPickerEnabled && (React.createElement(SubjectPicker, { ref: function (ref) { return (_this.subjectPickerElement = ref); }, targetElement: this.subjectLineElement, isOpened: this.props.composeViewState.subjectPickerViewState.isPickerOpened, composeViewState: this.props.composeViewState, onDismiss: this.onSubjectPickerDismiss, onConversationSelected: this.onSubjectConversationSelected }))));
    };
    SubjectLine.prototype.componentDidUpdate = function () {
        this.updateSelectionRange();
    };
    SubjectLine.prototype.updateSelectionRange = function () {
        var subjectViewState = this.props.composeViewState.subjectViewState;
        var _a = this.subjectInput, selectionStart = _a.selectionStart, selectionEnd = _a.selectionEnd;
        if (selectionStart != subjectViewState.selectionStart ||
            selectionEnd != subjectViewState.selectionEnd) {
            updateSubjectSelectionRange(this.props.composeViewState, selectionStart, selectionEnd);
        }
    };
    SubjectLine.prototype.isSubjectPickerEnabled = function () {
        return (isSubjectPickerSupported() &&
            this.props.composeViewState.subjectPickerViewState.supportsSubjectPicker);
    };
    SubjectLine.prototype.shouldOpenSubjectPicker = function () {
        return (!this.props.composeViewState.subjectPickerViewState.isPickerOpened &&
            this.props.composeViewState.subject === '' &&
            this.props.composeViewState.initialContent === this.props.composeViewState.content &&
            this.isOnlyOneToRecipient());
    };
    SubjectLine.prototype.isOnlyOneToRecipient = function () {
        return (getRecipientsCount(this.props.composeViewState.toRecipientWell) === 1 &&
            getRecipientsCount(this.props.composeViewState.ccRecipientWell) === 0 &&
            getRecipientsCount(this.props.composeViewState.bccRecipientWell) === 0);
    };
    SubjectLine = tslib_1.__decorate([
        observer
    ], SubjectLine);
    return SubjectLine;
}(React.Component));
export default SubjectLine;
//# sourceMappingURL=SubjectLine.js.map